import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';
import { GeometricFormState } from '../../state/geometric-form.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'edge' })
export class EdgeStore extends EntityStore<GeometricFormState> {

  constructor() {
    super({
      ui: { visible: true }
    });
    this.setLoading(false);
  }

}
